import useMode from '../../../../../utils/hooks/useMode';
import { EnumMode } from '../../../../../utils/context/Mode.context';
import ProjectPitches from './components/ProjectPitches';
import MyPitches from './components/MyPitches';

const PitchesList = () => {
  const { mode } = useMode();

  return mode === EnumMode.Client ? <ProjectPitches /> : <MyPitches />;
};
export default PitchesList;
